import React from 'react'
import axios from 'axios'
import { authService } from '../auth';

import httpService from '../AxiosInterceptors';
import Comment from "../commons/Comment";
import Share from "../commons/Share";
import AddCommentBox from "../commons/AddCommentBox";
import Follow from "../commons/Follow";
import { audioTimeFormat, fancyTimeFormat, getCDNUrl, getOptimizedArticleImage, getPercentageData, redirectToCircle, redirectToHashTags, redirectToProfile, userAgentGetData } from "../commons/CommonFunctions";
import NotFound from '../404';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import EntityFollow from "../commons/EntityFollow";
import "./main-explore.min.css";
import cloneDeep from "lodash/cloneDeep";
import Linkify from "react-linkify";
import { renderToString } from 'react-dom/server';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { pageClickRequest } from '../reducer/blogPageClick/blogPageClick';
import AudioPlayer from 'react-h5-audio-player';
import UserReactionComponent from '../UserReaction/UserReactionComponent';
import uuid from 'react-uuid';
import alertPopUp from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';
import { pageClickHookPostMethod } from '../services/PostApi';

const ErorrMsgPopUp = withReactContent(alertPopUp)

var dateFormat = require('dateformat');

httpService.setupInterceptors();

var userId;

function matchHashTags(text) {
    if (!text || text.length === 0) {
        return text;
    }
    var string = text;
    var regex = /(#[a-z\d-_]+)/gi;
    var matches = string.matchAll(regex);
    for (var match of matches) {
        if (match && match.length > 1) {
            string = string.replace(match[0],
                '<a class=\"hashLinkPost\" href="/explore-hashtag/' + match[0].substr(1) + '">' + match[0].substr(1) + '</a>');
        }
    }
    return string;
}
function transform(node, index) {
    if (node.type === 'text') {
        let modifiedString = matchHashTags(node.data)
        if (modifiedString !== node.data) {
            node.type = 'tag';
            node.name = 'div';
            return <>{ReactHtmlParser(modifiedString)}</>
        }
    }
}

const options = {
    decodeEntities: true,
    transform
};

const maxMbFileSize = 15 * 1024 * 1024; // 15MB
class ExploreDetailPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loginSuccess: authService.isAuthenticated(),
            userData: authService.getUserDetailsFromLocalStorage(),
            detailObj: {},

            item: {},
            comments: [],
            commentBtnActive: false,
            commentCount: 0,

            liked: false,
            likesCount: 0,
            notFoundstatusCode: '',
            page: 0,
            size: 5,
            audioS3Url: '',
            audioDuration: "",
            showAudioDurationFlag: false,
            coverImagePreview: null,
            blogImageUpdateId: "",
            triggerHookPost: false
        };
    }

    handleLike = () => {
        let newState = !this.state.liked;
        this.setState({ 'liked': newState })

        const data = {
            userId: this.state.userData.userId,
            activityId: this.state.item.id,
            liked: newState,
            likeEvent: "LIKE"
        }

        axios({
            method: 'post',
            url: process.env.REACT_APP_userServiceURL + '/backend/like/create/',
            data: data,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!') {
                this.setState({
                    'likesCount': newState ? this.state.likesCount + 1 : Math.max(0, this.state.likesCount - 1)
                })
            } else {
                this.setState({ 'liked': !newState })
            }
        }).catch((err) => {
            this.setState({ 'liked': !newState })
            console.log(err);
        });
    }

    handleHook = () => {
        let postBody = {
            userId: this.state.userData && this.state.userData.userId,
            entityId: this.state.item.id,
            timestamp: new Date().valueOf(),
            entityType: "BLOG",
        };
        this.props.pageClickRequest(postBody);
    }

    componentDidMount() {
        // window.$(".expldesctophead").sticky({topSpacing: 65, responsiveWidth: true});
        // if (window.$('#sticky-wrapper').hasClass('sticky-wrapper'))
        //     window.$('.projectinn').css({'padding-bottom' : '150px'});
        var navPos = window.$(".expldesctophead").offset().top - 64;
        window.$(window).scroll(function () {
            var windscroll = window.$(window).scrollTop();
            if (windscroll >= navPos) {
                window.$(".expldesctophead").addClass("is-sticky");
            } else {
                window.$(".expldesctophead").removeClass("is-sticky");
            }
        });


        window.$('.collapser').click(function () {
            window.$(this).next().collapse('toggle');
        });
        window.$('#commntIco').on('click', function (event) {
            event.preventDefault();
            window.$('#commentbox textarea').focus();
        });

        this.initFunction();
        setTimeout(() => this.handlePageClickHookPost(), 20000)
    }

    fetchMoreCommentData = () => {
        this.setState(
            { isResultLoading: true, page: this.state.page + 1 },
            () => {
                this.getAllComments(this.state.page, this.state.size, true);
            }
        );
    };

    getAllComments = (page, size, concatWithPrevious) => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/comment/getCommentsByActivityId/'
                + this.state.item.id + '?userId=' + this.state.userData.userId + "&page=" + page + "&size=" + size,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!') {
                let pagedData = response.data.body;
                if (concatWithPrevious) {
                    if (this.state.comments.content && this.state.comments.content.length > 0) {
                        let comments = cloneDeep(
                            this.state.comments.content
                        );
                        pagedData.content = comments.concat(pagedData.content);
                    }
                }
                this.setState({
                    'comments': pagedData,
                    // 'commentCount': response.data.body.totalElements,
                    'pagination': response.data.body.last
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    }


    initFunction() {
        userId = this.state.userData.userId;

        if (this.props.type === 'article') {
            this.getArticleDetaiPage();
        } else if (this.props.type === 'blog') {
            this.getBlogDetaiPage();
        }
    }

    getBlogDetaiPage() {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/backend/explore_service/api/explore_blog/getBySlug?slug=' + this.props.slug + '&userId=' + userId,
            withCredentials: true
        }).then(response => {
            if (response && response.data.body !== null) {
                var dataObj = {
                    "header": response.data.body.title,
                    "txt_data": response.data.body.content,
                    "date": response.data.body.createTime,
                    "summary_text": response.data.body.hashTags,
                    "image_url": response.data.body.coverImageUrl,
                    "name": response.data.body.source,
                    "likesCount": response.data.body.likesCount,
                    "commentCount": response.data.body.commentCount,
                    "userProfileImage": "https://cdn.dscovr.com/images/welogoNew.png"
                };
                document.title = response.data.body.metaTitle;
                this.setState({
                    "item": response.data.body,
                    "detailObj": dataObj,
                    "commentCount": dataObj.commentCount,
                    "liked": response.data.body.liked,
                    "likesCount": response.data.body.likesCount
                }, () => {
                    this.getTextToSpeech()
                });
                this.handleHook();
                this.getAllComments(this.state.page, 5, false);
            }
        }).catch((err) => {
            if (err && err.response && err.response.status === 404) {
                this.setState({
                    notFoundstatusCode: err.response.status
                })
            }
            this.setState({
                isLoaded: true,
                error: { message: err.response.data.message, err: err.response }
            });
        });
    }

    //Get text to speech voice data 
    getTextToSpeech = () => {
        let data = {
            postId: this.state.item?.id
        }
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_userServiceURL}/recommend/ttsdata`,
            data: data,
            withCredentials: true
        }).then((response) => {
            if (response?.data?.data) {
                this.setState({
                    audioS3Url: response?.data?.data
                }, () => {
                    if (this.state.audioS3Url && this.state.audioS3Url.length > 0) {
                        document.getElementsByClassName("rhap_progress-section")[0].classList.add("d-none");
                        const audio = document.querySelector('audio');
                        audio.addEventListener('loadedmetadata', (event) => {
                            this.setState({
                                audioDuration: event.target.duration,
                                showAudioDurationFlag: true,
                            })
                        });
                    }
                })
            }
        }).catch((error) => {
            console.log("Error", error);
        })
    }

    onListenAudio = (data) => {
        if(!this.state.triggerHookPost && getPercentageData(parseInt(this.state.audioDuration), 5) < data.target.currentTime) {
            this.setState({triggerHookPost: true})
            this.handlePageClickHookPost();
        }
    }

    handlePageClickHookPost = async () => {
        let postData = {
          entityId: this.state.item?.id,
          userId: this.state.userData?.userId,
          entityType: "POST"
        }
        await pageClickHookPostMethod(postData);
    }

    getArticleDetaiPage() {
        axios({
            method: 'get',
            url: `${process.env.REACT_APP_userServiceURL}/post/getBySlug?postRequestingUserId=${userId}&slug=${this.props.slug}&admin=false${userAgentGetData()}`,
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.statusCode === 200
                && response.data.body !== undefined) {

                var dataObj = {
                    "header": response.data.body.title,
                    "txt_data": response.data.body.description,
                    "date": response.data.body.createTime,
                    "summary_text": response.data.body.hashTags,
                    "image_url": this.getCoverImgUrl(response.data.body.attachmentIds),
                    "name": response.data.body.userName,
                    "likesCount": response.data.body.likesCount,
                    "commentCount": response.data.body.commentCount,
                    "userProfileImage": response.data.body.userProfileImage,
                    "userCustomUrl": response.data.body.userCustomUrl,
                    "userId": response.data.body.userCustomUrl,
                    "userType": response.data.body.userType
                };

                document.title = response.data.body.title;

                this.setState({
                    "item": response.data.body,
                    "detailObj": dataObj,
                    "liked": response.data.body.liked,
                    "likesCount": response.data.body.likesCount
                }, () => {
                    this.getTextToSpeech()
                });
                this.handleHook();
                this.getAllComments(this.state.page, 5, false);
            }


        }).catch((err) => {
            if (err && err.response && err.response.status === 404) {
                this.setState({
                    notFoundstatusCode: err.response.status
                })
            }
            this.setState({
                isLoaded: true,
                error: { message: err.response.data.message, err: err.response }
            });
        });
    }


    getCoverImgUrl(arttachmentList) {
        var attachmentUrl = "https://cdn.dscovr.com/images/banner-explore-blog-small-new.png";
        if (arttachmentList !== undefined) {
            for (var each of Object.values(arttachmentList)) {
                if (each.attachmentType === "COVER_IMAGE") {
                    attachmentUrl = getOptimizedArticleImage(each);
                    break;
                }
            }
        }
        return attachmentUrl;
    }

    getFormattedDate(milliseconds) {

        var utcSeconds = milliseconds;
        var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
        d.setUTCSeconds(utcSeconds / 1000);

        if (isNaN(d) === false) {
            if (dateFormat(d, "yyyy") === new Date().getFullYear().toString()) {
                return dateFormat(d, "dd-mmm");
            } else {
                return dateFormat(d, "dd-mmm-yyyy");
            }
        }
        return "";
    }

    refresh_comment = () => {
        this.setState({
            page: 0,
            size: 5
        }, () => {
            this.getAllComments(this.state.page, 5, false)
        })
    }

    renderTaggedUsers = (text) => {
        if (!text || text.length === 0) {
            return text;
        }
        text = text.split("@@@__").join("<a href=\"/profile/");
        text = text.split("^^__").join("\">")
        text = text.split("&&__").join("\">")
        text = text.split("&amp;&amp;__").join("\">")
        text = text.split("&amp;&amp;__").join("\">")
        text = text.split("@@@^^^").join("</a>");
        text = text.split("###__").join("<a class=\"hashLinkPost\" style=\"cursor:pointer\" href=\"/explore-hashtag/");
        text = text.split("&&__").join("<a class=\"hashLinkPost\" style=\"cursor:pointer\" href=\"/explore-hashtag/");
        text = text.split("###^^^").join("</a>");
        return text;
    }

    onPlayAudio = () => {
        document.getElementsByClassName("rhap_progress-section")[0].classList.remove("d-none");
        this.setState({
            showAudioDurationFlag: false
        })
    }

    getTranslationToEnglish = () => {
        let data = {
            postId: this.state.item?.id
        }
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_userServiceURL}/recommend/`,
            data: data,
            withCredentials: true
        }).then((response) => {
            if (response?.data?.data) {
                this.getTextToSpeech()
            }
        }).catch((error) => {
            console.log("Error", error);
        })
    }

    coverImageUpload = () => {
        this.refs.blogCoverImageFileUploader.click();
    };

    uploadCoverImageFile = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            let fileSize = e.target.files[0].size;
            const fileName = e.target.files[0].name;
            const idxDot = fileName.lastIndexOf(".") + 1;
            const extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
            const allowedAttachmentsTypeArr = ["jpg", "jpeg", "png"];
            if (!allowedAttachmentsTypeArr.includes(extFile)) {
                this.errorMessageData(`Only ${allowedAttachmentsTypeArr.join("/")} files are allowed!`);
            } else if (fileSize > maxMbFileSize) {
                this.errorMessageData("Uploaded file exceeds limit of 15 MB");
            } else {
                this.setState({
                    coverImagePreview: URL.createObjectURL(e.target.files[0])
                });
                let currentFile = e.target.files[0];
                this.uploadImageAttachment(currentFile);
            }
        }
    };

    uploadImageAttachment(currentFile) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("file", currentFile);
            formData.append("userId", this.state.userData.userId);
            formData.append("attachmentType", "COVER_IMAGE");
            axios({
                method: "post",
                url: `${process.env.REACT_APP_userServiceURL}/backend/post/uploadAttachment`,
                data: formData,
                withCredentials: true
            }).then((response) => {
                    if (response && response.data && response.data.body) {
                        this.updateBlogImageData(response.data.body?.id);
                    }
                    resolve();
            }).catch((e) => {
                console.log(e);
                reject(e);
            });
        });
    }

    updateBlogImageData = (attachmentId) => {
        let postData = {
            attachmentId: attachmentId,
            postId: this.state.item?.id
        }
        axios({
            method: "post",
            url: `${process.env.REACT_APP_userServiceURL}/backend/post/update/banner-image`,
            data: postData,
            withCredentials: true
        }).then((response) => {
                if (response && response.data && response.data.body) {
                    
                }
        }).catch((e) => {
            console.log(e);
        });
    }


    errorMessageData = (message) => {
        ErorrMsgPopUp.fire({
            didOpen: () => {
                ErorrMsgPopUp.clickConfirm();
            }
        }).then((result) => {
            return ErorrMsgPopUp.fire({
                allowOutsideClick: false,
                allowEscapeKey: false,
                title: <>{message}</>,
            })
        })
    }


    render() {
        let linkfiedHtml = "<p class=\"pdtlsLink\">" + this.renderTaggedUsers(renderToString(
            window.ReactNativeWebView ? <Linkify>{this.state.detailObj && this.state.detailObj.txt_data
                ? this.state.detailObj && this.state.detailObj.txt_data.replace(/<br\/>/g, '\n').replace(/&nbsp;/g, ' ')
                : ''}</Linkify> : <Linkify
                    componentDecorator={(decoratedHref, decoratedText, key) => (
                        <a target="blank" href={decoratedHref} key={key}>
                            {decoratedText}
                        </a>
                    )}>{this.state.detailObj && this.state.detailObj.txt_data
                        ? this.state.detailObj && this.state.detailObj.txt_data.replace(/<br\/>/g, '\n').replace(/&nbsp;/g, ' ')
                        : ''}</Linkify>
        )).replace(/&nbsp;/g, ' ')
            .replace(/(\r\n|\r|\n)/g, '<br>')
            .replace(/(\\n)/g, '<br>') + "</p>";
        linkfiedHtml = renderToString(ReactHtmlParser(linkfiedHtml, options));
        if (this.state.notFoundstatusCode === 404) {
            return <div className="col-md-12"><NotFound /></div>
        } else {
            return <div className="col-md-12">
                <div className="projectinn explinner expDtlsWrap">
                    <div className="explpagebannwrap">
                        {/* {this.state.item?.creatorId === this.state.userData.userId &&  */}
                        {this.state.item?.bannerImageChangePermission && 
                            <>
                                <input type="file" accept="image/*" id="blogImageUploader" onChange={this.uploadCoverImageFile} ref="blogCoverImageFileUploader" style={{ display: "none" }} />
                                <button type="button" className="browse btn btn-primary" onClick={this.coverImageUpload}>Change Image</button>
                            </>
                        }
                        {this.state.coverImagePreview ? (
                            <LazyLoadImage style={{ maxWidth: '100%' }} effect="blur" src={this.state.coverImagePreview} alt="" />
                        ) : <a data-fancybox={uuid()} href={this.state.detailObj !== undefined && this.state.detailObj.image_url !== undefined ? getCDNUrl(this.state.detailObj.image_url) : ''}>
                                <LazyLoadImage effect="blur" src={this.state.detailObj !== undefined && this.state.detailObj.image_url !== undefined ? getCDNUrl(this.state.detailObj.image_url) : ''} alt="" />
                            </a>
                        }
                    </div>
                    <div className="expldesctophead">
                        <div className="fdtheadleft">
                            {

                                this.state.detailObj && this.state.detailObj.news_url &&
                                (
                                    <h1><a
                                        href={this.state.detailObj.news_url}
                                        target="_blank">{this.state.detailObj !== undefined ? this.state.detailObj.header : ''}</a>
                                    </h1>
                                )

                            }
                            {

                                this.state.detailObj !== undefined && this.state.detailObj.news_url === undefined &&
                                (
                                    <h1>{this.state.detailObj !== undefined ? this.state.detailObj.header : ''}</h1>
                                )

                            }
                            {/* <Reader textToRead={stripHtml(linkfiedHtml)}/> */}
                            {this.state.audioS3Url && this.state.audioS3Url.length > 0 &&
                                <div className={this.state.audioDuration && this.state.showAudioDurationFlag ? 'audioSpeakWrap noBar' : 'audioSpeakWrap'}>
                                    <AudioPlayer
                                        showJumpControls={false}
                                        customVolumeControls={[]}
                                        customAdditionalControls={[]}
                                        showDownloadProgress={false}
                                        src={this.state.audioS3Url}
                                        onPlay={this.onPlayAudio}
                                        onListen={(e) => this.onListenAudio(e)}
                                    />
                                    {this.state.audioDuration && this.state.showAudioDurationFlag && <span className='beforePlay'>{audioTimeFormat(this.state.audioDuration)}</span>}
                                </div>
                            }
                        </div>
                        <div className="fdtheadright">
                            <div className="fdtheadrightbott">
                                <div className="forumrowbright">

                                    {
                                        this.state.item && this.state.item.likesCount !== undefined &&
                                        (
                                            <UserReactionComponent item={this.state.item} key={this.state.item.id} />
                                        )
                                    }

                                    <div className="expCommnt">
                                        <a href="javascript:void(0)" className="comments" id="commntIco">
                                            <span>{this.state.item.commentCount}&nbsp;
                                                <span>{this.state.item.commentCount <= 1 ? 'Comment' : 'Comments'}</span></span>
                                        </a>
                                    </div>

                                    {
                                        this.props.type === 'article' &&
                                        (
                                            <>
                                                {
                                                    this.state.item && this.state.item.id &&
                                                    <Share shareUrl="/explore-detail/article/"
                                                        hideShareOnPortalBtn={(this.state.item.postVisibility !== 'ANYONE')}
                                                        entityId={this.state.item.id}
                                                        slug={this.state.item.slug}
                                                        sharesCount={this.state.item.sharesCount}
                                                        entityType={"POST"}
                                                        shareId={this.state.item.id} />
                                                }
                                            </>
                                        )
                                    }

                                    {
                                        this.props.type === 'blog' &&
                                        <>
                                            {window.location.href.indexOf('share-open') !== -1 ?
                                                this.state.item && this.state.item.slug &&
                                                <Share shareUrl={"/explore-detail/blog/"}
                                                    entityId={this.state.item.id}
                                                    entityType={"EXPLOREBLOG"}
                                                    sharesCount={this.state.item.sharesCount}
                                                    slug={this.state.item.slug}
                                                    shareId={this.state.item.id}
                                                    shareOpen='true' /> :
                                                this.state.item && this.state.item.slug &&
                                                <Share shareUrl={"/explore-detail/blog/"}
                                                    entityId={this.state.item.id}
                                                    sharesCount={this.state.item.sharesCount}
                                                    entityType={"EXPLOREBLOG"}
                                                    slug={this.state.item.slug}
                                                    shareId={this.state.item.id} />}
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                        <a href="javascript:void(0)" className="bookmark"><i className="iBookmark_F" /></a>
                    </div>

                    <div className="expldescmain">
                        <div className="expldescall">
                            {
                                this.state.detailObj && this.state.detailObj.news_url &&
                                (
                                    <h1><a
                                        href={this.state.detailObj.news_url}
                                        target="_blank">{this.state.detailObj !== undefined ? this.state.detailObj.header : ''}</a>
                                    </h1>
                                )

                            }
                            {

                                this.state.detailObj !== undefined && this.state.detailObj.news_url === undefined &&
                                (
                                    <h1>{this.state.detailObj !== undefined ? this.state.detailObj.header : ''}</h1>
                                )

                            }
                            <div className='blogPublistInfo'>
                                <div className="fuserfollow">
                                    {!this.state.item.userEntityType ?
                                        (this.state.item.userType === 'INDIVIDUAL' ?
                                            <>{this.props.type === 'blog' ? <figure className="userlogo welogo"><img
                                                src={this.state.detailObj.userProfileImage !== undefined && this.state.detailObj.userProfileImage !== '' && this.state.detailObj.userProfileImage !== null ? getCDNUrl(this.state.detailObj.userProfileImage) : 'https://cdn.dscovr.com/images/users1.png'}
                                                alt="" /></figure> : <figure className="userlogo" onClick={(e) => {
                                                    e.preventDefault();
                                                    redirectToProfile(this.state.detailObj.userCustomUrl, this.state.detailObj.userId, this.state.detailObj.userType, this.state.userData.userId)
                                                }} style={{ cursor: 'pointer' }}><img
                                                    src={this.state.detailObj.userProfileImage !== undefined && this.state.detailObj.userProfileImage !== '' && this.state.detailObj.userProfileImage !== null ? getCDNUrl(this.state.detailObj.userProfileImage) : 'https://cdn.dscovr.com/images/users1.png'}
                                                    alt="" /></figure>}</> :
                                            <>{this.props.type === 'blog' ? <figure className="userlogo welogo"><img
                                                src={this.state.detailObj.userProfileImage !== undefined && this.state.detailObj.userProfileImage !== '' && this.state.detailObj.userProfileImage !== null ? getCDNUrl(this.state.detailObj.userProfileImage) : 'https://cdn.dscovr.com/images/DefaultBusiness.png'}
                                                alt="" /></figure> : <figure className="userlogo" onClick={(e) => {
                                                    e.preventDefault();
                                                    redirectToProfile(this.state.detailObj.userCustomUrl, this.state.detailObj.userId, this.state.detailObj.userType, this.state.userData.userId)
                                                }} style={{ cursor: 'pointer' }}><img

                                                    src={this.state.detailObj.userProfileImage !== undefined && this.state.detailObj.userProfileImage !== '' && this.state.detailObj.userProfileImage !== null ? getCDNUrl(this.state.detailObj.userProfileImage) : 'https://cdn.dscovr.com/images/DefaultBusiness.png'}
                                                    alt="" /></figure>}</>) :
                                        <figure className="userlogo" onClick={(e) => {
                                            e.preventDefault();
                                            redirectToCircle(this.state.item.params && this.state.item.params['circleSlug'])
                                        }}>
                                            <img
                                                src={this.state.item.params && this.state.item.params['circleImage'] != null
                                                    ? getCDNUrl(this.state.item.params && this.state.item.params['circleImage'])
                                                    : "https://cdn.dscovr.com/images/circleDefault.png"}
                                                alt="" />
                                        </figure>
                                    }


                                    {
                                        this.props.type !== 'blog' ?
                                            (!this.state.item.userEntityType ?
                                                (<div onClick={(e) => {
                                                    e.preventDefault();
                                                    redirectToProfile(this.state.detailObj.userCustomUrl, this.state.detailObj.userId, this.state.detailObj.userType, this.state.userData.userId)
                                                }}
                                                    style={{
                                                        cursor: 'pointer',
                                                        textTransform: 'capitalize'
                                                    }}>{this.state.detailObj.name ? this.state.detailObj.name : ''}
                                                </div>) :
                                                (<div onClick={(e) => {
                                                    e.preventDefault();
                                                    redirectToCircle(this.state.item.params && this.state.item.params['circleSlug'])
                                                }}
                                                    style={{
                                                        cursor: 'pointer',
                                                        textTransform: 'capitalize'
                                                    }}>{this.state.item.params && this.state.item.params['circleTitle'] ? this.state.item.params['circleTitle'] : ''}
                                                </div>))
                                            :
                                            (<div
                                                style={{ textTransform: 'capitalize' }}>{this.state.detailObj.name ? this.state.detailObj.name : ''}
                                            </div>)
                                    }


                                    {!this.state.item.userEntityType &&
                                        this.state.item && this.state.item.userId &&
                                        <Follow key={this.state.item.userId}
                                            followed={this.state.item.followed}
                                            userId={this.state.item.userId}
                                            deactivated={this.state.item.deactivated} />
                                        // :
                                        // <EntityFollow entityType={'CIRCLE'} entityId={this.state.item.params['circleId']} followed={this.state.item.followed}
                                        //               userId={this.state.userData.userId} isCircle={true}/>
                                    }
                                </div>
                                {
                                    this.state.item && this.state.item.publishedTime && this.state.item.publishedTime != 0 ?
                                        (
                                            <div className='publishBlk'>Published on {this.getFormattedDate(this.state.item.publishedTime)}</div>
                                        ) : <div className='publishBlk'>Published on {this.getFormattedDate(this.state.item.createTime)}</div>
                                }
                            </div>
                            <hr />


                            {this.state.detailObj !== undefined && this.state.detailObj.html_text !== undefined &&
                                (
                                    <div dangerouslySetInnerHTML={{ __html: this.state.detailObj.html_text }} />
                                )
                            }

                            {this.state.detailObj !== undefined && this.state.detailObj.html_text === undefined && this.state.detailObj.txt_data !== undefined &&
                                (
                                    <div dangerouslySetInnerHTML={{
                                        __html: this.state.detailObj && this.state.detailObj.txt_data ? this.state.detailObj.txt_data : ""
                                    }} />
                                )
                            }

                            <div className="tagsblk">
                                {
                                    (this.state.detailObj !== undefined && this.state.detailObj.summary_text !== undefined) &&
                                    Object.values(this.state.detailObj.summary_text).map((hashTag, val, idx) => {
                                        return (this.props.type == 'blog' ?
                                            <span className="hashLinkPost">{hashTag}</span>
                                            :
                                            <a href="javascript:void(0)" onClick={(e) => redirectToHashTags(hashTag)}>#{hashTag}</a>)
                                        {/* idx <= 2 &&  */ }
                                    })
                                }
                            </div>
                        </div>
                    </div>

                    <div className="forumdescbott">
                        <div className="row">
                            <div className="col-lg-12">


                                <div className="commentglobal-explore" id="commentBoxId">
                                    <AddCommentBox item={this.state.item} getAllComments={this.getAllComments} pageType={"EXPLORE_DETAILS"} />
                                    {
                                        this.state.comments && this.state.comments.content && this.state.comments.content.length > 0 &&
                                        <div className="forumcommtvlistwrap scrollbar-primary">
                                            {
                                                this.state.comments && this.state.comments.content && this.state.comments.content.map((comment) => {
                                                    return <Comment item={comment} key={comment.id}
                                                        callback={this.getAllComments} refresh={this.refresh_comment} />
                                                })
                                            }
                                        </div>
                                    }
                                    {!this.state.pagination && <div className='text-center' style={{ paddingBottom: '8px', paddingTop: '8px' }}><a href="javascript:void(0)" onClick={(e) => this.fetchMoreCommentData()} className='btn cLoadmore'>Load More</a></div>}
                                </div>


                                <div className="forumcommtvlistwrap">

                                    {
                                        /*<Comment/>
                                    <Comment/>
                                    */}

                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        }
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        pageClickRequest: (data) => dispatch(pageClickRequest(data)),
    }
};

export default connect(null, mapDispatchToProps)(ExploreDetailPage);
